import { get } from "../../service/api";

const GetFaultyBankTransactionLog = async (queryString) => {
  try {
    const response = await get(
      `/admin/faultyBankTransactionLog?1=1&${queryString}`
    );
    return response;
  } catch (error) {
    console.error("Error GetFaultyBankTransactionLog:", error);
    throw error;
  }
};

export default GetFaultyBankTransactionLog;
